import { ref, watch } from "vue";
const modals = ref({});
const currentModal = ref(null);
const useModalPage = () => {
  const register = ({ name, component, props, modalProps }) => {
    modals.value[name] = {
      component,
      props,
      modalProps
    };
  };
  const show = ({ name, component, props, modalProps }) => {
    const modal = name ? modals.value[name] : { component };
    if (modal) {
      currentModal.value = {
        component: modal.component,
        props: {
          ...modal.props,
          ...props
        },
        modalProps: {
          ...modal.modalProps,
          ...modalProps
        }
      };
    }
    return new Promise((resolve) => {
      if (!currentModal.value) return resolve();
      const unwatch = watch(currentModal, (val) => {
        if (!val) {
          unwatch == null ? void 0 : unwatch();
          resolve();
        }
      });
    });
  };
  const hide = (props) => {
    if (currentModal.value) {
      currentModal.value = null;
    }
  };
  return {
    modals,
    currentModal,
    register,
    show,
    hide
  };
};
export {
  useModalPage
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
